export const getLocation = (retries = 2) => {
    return new Promise((resolve) => {
        if (!navigator.geolocation) {
            resolve({ status: "NOT_SUPPORTED" });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    status: "OK",
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
                console.log('position',position);
            },
            (err) => {
                // Permission denied
                if (err.code === 1) {
                    resolve({ status: "PERMISSION_DENIED" });
                    return;
                }

                // iOS: location unknown → retry
                if (err.code === 2 && retries > 0) {
                    setTimeout(() => {
                        getLocation(retries - 1).then(resolve);
                    }, 2000);
                    return;
                }

                // Final failure
                resolve({ status: "LOCATION_UNAVAILABLE" });
            },
            {
                enableHighAccuracy: true,
                timeout: 2000,
                maximumAge: 0,
            }
        );
    });
};
